import { Component, OnInit, Input } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatDialog } from '@angular/material/dialog';
import { UtilService, VariablesService, VwoService } from '../../../../shared/services';
import { PaymentUtilService } from 'src/app/common/payment/services';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-upi-icons',
  templateUrl: './upi-icons.component.html',
  styleUrls: ['./upi-icons.component.scss']
})
export class UpiIconsComponent implements OnInit {

  @Input() origin;
  @Input() isSipStory;
  @Input() userdata;
  @Input() tagLabel;
  @Input() recommendTag;
  @Input() theme;
  isBtnClicked = false;
  mode;
  qParams;
  options: any = [
    { label: 'Paytm', name: '', position: '-44px -966px', payment: 'PAYTM', mode: 'WALLET' },
    { label: 'Google Pay', name: 'tez', position: '-46px -603px', payment: 'GooglePay', mode: 'UPI' },
    { label: 'Whatsapp Pay', name: 'whatsapp_pay', position: '-46px -543px', payment: 'Whatsapp', mode: 'UPI' },
    { label: 'Phone Pe', name: 'Phone_pe', position: '-46px -662px', payment: 'PhonePe', mode: 'UPI' },
    { label: 'BHIM', name: 'bhim', position: '-46px -722px', payment: 'BHIM', mode: 'UPI' },
    { label: 'Mobikwik', name: 'mobikwik', position: '-46px -782px', payment: 'MOBIKWIK', mode: 'UPI' },
    { label: 'OLA', name: 'ola', position: '-46px -841px', payment: 'OLAMONEY', mode: 'UPI' },
    { label: 'Other UPIs', name: 'other_upi', position: '-46px -902px', payment: 'OTHER', mode: 'UPI' },
  ];

  subs: Subscription[] = [];

  constructor(
    public dialog: MatDialog,
    public vars: VariablesService,
    public util: UtilService,
    public vwo: VwoService,
    private sheet: MatBottomSheet,
    public actRoute: ActivatedRoute,
    private paymentUtilService: PaymentUtilService
  ) { }

  ngOnInit() {
    this.qParams = this.actRoute.snapshot.queryParams;
  }

  upiOnClick(item, paymentModule, template) {
    this.mode = {
      value: item.payment,
      mode: item.mode
    };
    if (this.userdata && this.vwo.story_one_tap_AB()) {
      this.sheet.open(template, {
        panelClass: 'payment-sheet'
      });
      return false;
    }
    this.isBtnClicked = true;
    if (!this.qParams?.sip_story) {
      this.paymentUtilService.contributeInitiatedEvents();
    }
    this.dialog.open(paymentModule, {
      width: '100vw',
      maxWidth: '600px',
      height: '100vh',
      maxHeight: 'auto',
      panelClass: 'payment-dialog',
      disableClose: true,
      closeOnNavigation: false
    });
    this.checkForUpiPayment();
  }

  checkForUpiPayment() {
    this.subs.push(
      this.vars.upi_payment_status.subscribe(val => {
        if (val === 'success') {
          this.dialog.closeAll();
          this.vars.upiTimer = false;
          this.util.router.navigate(['/new/payment-route'], { queryParams: this.vars.tyParams });
        } else if (val === 'failed') {
          this.vars.upiTimer = false;
        }
      })
    );
  }
}
